/**
 * Indica si el contrato o apartado tiene bloqueado el pago con tarjeta
 * (PayCash / PuntoRed siguen disponibles).
 * Activo cuando bloqueo/Bloqueo no es null ni cadena vacía.
 * @param {{ Bloqueo?: string|null, bloqueo?: string|null }|null|undefined} entity
 * @returns {boolean}
 */
export default function isPaymentCardBlocked(entity) {
  if (!entity || typeof entity !== 'object') {
    return false;
  }
  const v = entity.Bloqueo ?? entity.bloqueo;
  return v != null && String(v) !== '';
}
